<div class='row ba-mailbox'>

    <!--  LEFT-->
    <div class='col-12 col-sm-5 col-md-4 col-lg-3'>

        <!-- NEUE NACHRICHT-->
        @if (!postfachRestricted) {
            <button type='button' class='ba-btn ba-btn-primary ba-btn-block ba-btn-icon ba-icon-edit'
                    [attr.aria-label]="'mailbox.new-message'|i18next "
                    id="btn-nachricht-senden" (click)="navigateToEditor()">
                <span>{{ 'mailbox.new-message'|i18next }}</span></button>
        }

        <!-- ORDNER LISTE -->
        <kokos-postfach-folder-list [selectedFolder]='selectedFolder' [nachrichtFolders]='nachrichtenOrdner'
                                    (folderSelected)='navigateToFolder($event)'></kokos-postfach-folder-list>

        <!-- FILTER -->
        @if (this.benutzerRechte.kundenTyp === KundenTypeEnum.PERSON) {
            <kokos-postfach-filter [selectedFilter]='filter'
                                   (filterSelected)='setFilter($event)'></kokos-postfach-filter>
        }

        <!-- EINSTELLUNGEN-->
        <a [href]="profilEinstellenLink" id="kpf-link-benachrichtigungen-einstellen"
           title="{{ 'mailbox.settings-tooltip' | i18next }}"
           class='ba-link-icon ba-icon-settings'>{{ 'mailbox.settings' | i18next }}</a>
        <p></p>
    </div>

    <!-- MAIN-->
    <div class='col-12 col-sm-7 col-md-8 col-lg-9'>
        <kokos-postfach-header-search [nachrichtFolder]='selectedFolder' [searchInput]='sucheValue'
                                      [anzahlNachrichten]="getFilteredNachrichtCount()"
                                      (searchInputChanged)='onSearchInput($event)'></kokos-postfach-header-search>
        @if (isLoading) {
            <div class="ba-loading"></div>
        }

        <kokos-postfach-nachricht-list [nachrichtFolder]='selectedFolder' [selectedFilter]='filter'
                                       [nachrichten]='getNachrichenToShow()'
                                       [onlineKommunikation]='!postfachRestricted'
                                       (reload)='navigateToFolder($event)'></kokos-postfach-nachricht-list>

        <!--    showAllMessages-Button-->
        @if (this.nachrichtenListeVoll != null && this.getFilteredNachrichtCount() > this.MAX_NACHRICHTEN && !this.showAlleNachrichten) {
            <div class='text-center'>
                <button class='ba-btn' id='btn-show-all' type='button' (click)='showAllNachrichten()'
                        [attr.aria-label]="'mailbox.show-all-messages' | i18next:{count:getFilteredNachrichtCount()}">
                    {{ 'mailbox.show-all-messages' | i18next:{count: getFilteredNachrichtCount()} }}
                </button>
            </div>
        }

    </div>

    <!-- FEEDBACK-->
    <kokos-postfach-feedback></kokos-postfach-feedback>

</div>
